var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_vm._v(" "),_c('about-area'),_vm._v(" "),_c('choose-area'),_vm._v(" "),_c('testimonial-area'),_vm._v(" "),_c('delivery-area'),_vm._v(" "),_c('offer-area')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b74e812","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutUs.vue
// module id = null
// module chunks = 